import { render, staticRenderFns } from "./SecondaryLayout.vue?vue&type=template&id=24b12ffa"
import script from "./SecondaryLayout.vue?vue&type=script&lang=js"
export * from "./SecondaryLayout.vue?vue&type=script&lang=js"
import style0 from "./SecondaryLayout.vue?vue&type=style&index=0&id=24b12ffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports